/* eslint-disable import/prefer-default-export */

/*
 * The type of payment calculation is based on
 */
export enum PaymentEntityType {
  Transaction = "Transaction",
  Account = "Account",
}
